// @flow

import * as React from 'react';

import clsx from 'clsx';

import { Label } from '@gandi/ui';

import { Fieldset as FieldsetRaw } from 'gandi.react-form';

import styles from './Fieldset.scss';

type Props = {
  label: string,
  inputName: string,
  column?: boolean,
  children: React.Node,
};

export default function Fieldset({
  label,
  inputName,
  column,
  children,
}: Props): React.MixedElement {
  return (
    <FieldsetRaw
      className={clsx(styles.root, {
        [styles.column]: column,
        [styles.line]: !column,
      })}
    >
      <Label target={inputName}>{label}</Label>
      {children}
    </FieldsetRaw>
  );
}
